
export enum BlinkMode
{
    Blink = "Blink",
    LightUp = "Flash",
    Both = "Both"
}
